import { render, staticRenderFns } from "./commentsUl_flat.vue?vue&type=template&id=01e8d281&scoped=true&"
import script from "./commentsUl_flat.vue?vue&type=script&lang=js&"
export * from "./commentsUl_flat.vue?vue&type=script&lang=js&"
import style0 from "./commentsUl_flat.vue?vue&type=style&index=0&id=01e8d281&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8d281",
  null
  
)

export default component.exports